/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiUserFromJSON(json) {
    return StreemApiUserFromJSONTyped(json, false);
}
export function StreemApiUserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sid': !exists(json, 'sid') ? undefined : json['sid'],
        'companySid': !exists(json, 'company_sid') ? undefined : json['company_sid'],
        'externalUserId': !exists(json, 'external_user_id') ? undefined : json['external_user_id'],
        'isExpert': !exists(json, 'is_expert') ? undefined : json['is_expert'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'avatarUrl': !exists(json, 'avatar_url') ? undefined : json['avatar_url'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'roles': !exists(json, 'roles') ? undefined : json['roles'],
        'activeStatusModifiedAt': !exists(json, 'active_status_modified_at') ? undefined : (new Date(json['active_status_modified_at'])),
        'userTypes': !exists(json, 'user_types') ? undefined : json['user_types'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
        'bio': !exists(json, 'bio') ? undefined : json['bio'],
        'availabilityStatus': !exists(json, 'availability_status') ? undefined : json['availability_status'],
    };
}
export function StreemApiUserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sid': value.sid,
        'company_sid': value.companySid,
        'external_user_id': value.externalUserId,
        'is_expert': value.isExpert,
        'email': value.email,
        'name': value.name,
        'avatar_url': value.avatarUrl,
        'phone': value.phone,
        'active': value.active,
        'roles': value.roles,
        'active_status_modified_at': value.activeStatusModifiedAt === undefined ? undefined : (value.activeStatusModifiedAt.toISOString()),
        'user_types': value.userTypes,
        'deleted': value.deleted,
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'bio': value.bio,
        'availability_status': value.availabilityStatus,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiUserUserTypes;
(function (StreemApiUserUserTypes) {
    StreemApiUserUserTypes["INVITED"] = "USER_TYPE_INVITED";
    StreemApiUserUserTypes["LOGIN"] = "USER_TYPE_LOGIN";
    StreemApiUserUserTypes["SDK"] = "USER_TYPE_SDK";
    StreemApiUserUserTypes["UNSPECIFIED"] = "USER_TYPE_UNSPECIFIED";
})(StreemApiUserUserTypes || (StreemApiUserUserTypes = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiUserAvailabilityStatus;
(function (StreemApiUserAvailabilityStatus) {
    StreemApiUserAvailabilityStatus["AVAILABLE"] = "AVAILABILITY_STATUS_AVAILABLE";
    StreemApiUserAvailabilityStatus["CONFIRMING"] = "AVAILABILITY_STATUS_CONFIRMING";
    StreemApiUserAvailabilityStatus["INVALID"] = "AVAILABILITY_STATUS_INVALID";
    StreemApiUserAvailabilityStatus["INCALL"] = "AVAILABILITY_STATUS_IN_CALL";
    StreemApiUserAvailabilityStatus["NOTAVAILABLE"] = "AVAILABILITY_STATUS_NOT_AVAILABLE";
    StreemApiUserAvailabilityStatus["OFFLINE"] = "AVAILABILITY_STATUS_OFFLINE";
    StreemApiUserAvailabilityStatus["RESERVED"] = "AVAILABILITY_STATUS_RESERVED";
})(StreemApiUserAvailabilityStatus || (StreemApiUserAvailabilityStatus = {}));
//# sourceMappingURL=StreemApiUser.js.map